import React from "react";
import PropTypes from "prop-types";
import { Card, Typography, Avatar, Space } from "antd";
import { UserOutlined, CheckCircleFilled } from "@ant-design/icons";
import { baseImageUrl } from "Common/Components/baseImageUrl";
const { Text, Paragraph } = Typography;
const WelcomeCard = ({ styles, managerData, lastLogin }) => {
  return (
    <Card
      style={{
        ...styles.welcomeCard,
        borderRadius: '8px',
        padding: '12px 16px',
        marginBottom: 0,
        boxShadow: 'none',
        backgroundColor: "#FAF8F3"
      }}
      variant="borderless"
      styles={{ body: { padding: 0 } }}
    >
      <Space
        size="middle"
        align="center"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%'
        }}
      >
        <div>
          <Text strong style={{
            ...styles.textColor,
            fontSize: '18px',
            lineHeight: 1.3,
            display: 'block',
            marginBottom: '4px'
          }}>
            Welcome back, {managerData.firstName}!
          </Text>
          <Paragraph
            style={{
              ...styles.secondaryTextColor,
              fontSize: '16px',
              marginBottom: '4px',
              lineHeight: 1.2
            }}
          >
            Here is what is happening today
          </Paragraph>
          <Text
            type="secondary"
            style={{
              fontSize: '12px',
              color: '#8c8c8c',
              lineHeight: 1.2
            }}
          >
            Last: {lastLogin ? new Date(lastLogin).toLocaleDateString() : "N/A"}
          </Text>
        </div>

      </Space>
    </Card>
  );
};
WelcomeCard.propTypes = {
  styles: PropTypes.shape({
    welcomeCard: PropTypes.object,
    textColor: PropTypes.object,
    secondaryTextColor: PropTypes.object,
    darkMode: PropTypes.bool,
  }).isRequired,
  managerData: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    profileImage: PropTypes.string,
    isProfileDetailCompleted: PropTypes.bool,
  }).isRequired,
  lastLogin: PropTypes.any.isRequired,
};
export default WelcomeCard;